export const OUTLET_DETAILS_REQUEST = "OUTLET_DETAILS_REQUEST";
export const OUTLET_DETAILS_SUCCESS = "OUTLET_DETAILS_SUCCESS";
export const OUTLET_DETAILS_FAILURE = "OUTLET_DETAILS_FAILURE";

export const STORE_ANALYTICS_REQUEST = "STORE_ANALYTICS_REQUEST";
export const STORE_ANALYTICS_SUCCESS = "STORE_ANALYTICS_SUCCESS";
export const STORE_ANALYTICS_FAILURE = "STORE_ANALYTICS_FAILURE";
